import Container from "@material-ui/core/Container";
import { Box } from "@material-ui/system";
import { useGetEquipment } from "../api/api";
import { LabeledText } from "../components/LabeledText";
import { MainMenuToolbar } from "../components/MainMenuToolbar";
import formatStaticEquipment from "../helpers/formatStaticEquipment";
import { useGetShip } from "../api/api";
import type { ShipRouteProps } from "../types/routes";
import type { StaticEquipment } from "../types/models";

export const Ship = (props: ShipRouteProps) => {
  const shipId = props.match.params.shipId;

  const ship = useGetShip(shipId) as {
    title?: string;
    ldbf?: { min?: number | string; max?: number | string };
  };
  const { data: shipsEquipment = [] } = useGetEquipment(shipId) as {
    data: StaticEquipment[];
  };

  return (
    <div>
      <MainMenuToolbar title="Reports" />
      <Container maxWidth="sm">
        <LabeledText label="Name">{ship.title}</LabeledText>
        <LabeledText label="Ships standard LDBF">
          {ship.ldbf?.min} - {ship.ldbf?.max} tons
        </LabeledText>
        <LabeledText label="Available rope locations">
          {shipsEquipment.map((equipment) => {
            const cableTags = (equipment?.cables || [])
              .map((cable) => cable.tag)
              .join(", ");

            return (
              <Box mb={2}>
                {formatStaticEquipment(equipment)}
                <br />
                contains lines:{" "}
                {cableTags || "-"}
              </Box>
            );
          })}
        </LabeledText>
      </Container>
    </div>
  );
};
